import { useEffect, useState } from 'react';

const navLinks = [
  { label: '热门语音', href: '#hot' },
  { label: '分类入口', href: '#categories' },
  { label: '收听榜', href: '#ranking' },
  { label: '内容结构', href: '#trust' },
  { label: '常见疑问', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[68px] flex items-center justify-between gap-4">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-mic-2-fill text-background-50 text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-foreground-950 text-lg tracking-tight">
                黑料吃话
              </span>
              <span className="text-[10px] font-label text-foreground-500 tracking-[0.22em] mt-0.5">
                SOUND ARCHIVE
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3.5 py-2 text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* desktop actions */}
          <div className="hidden md:flex items-center gap-3">
            <div className="relative hidden xl:block">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                placeholder="搜索录音、对话、事件"
                className="w-56 pl-9 pr-3 py-2 text-sm font-label rounded-md bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition"
              />
            </div>
            <a
              href="#hot"
              className="whitespace-nowrap px-4 py-2 text-sm font-label rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始收听
            </a>
          </div>

          {/* mobile toggle */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-800 border border-background-200 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {/* mobile panel */}
      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 animate-fade-up">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm font-label text-foreground-800 border-b border-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#hot"
            onClick={() => setMenuOpen(false)}
            className="mt-4 block text-center whitespace-nowrap px-4 py-2.5 text-sm font-label rounded-md bg-primary-500 text-background-50 cursor-pointer"
          >
            开始收听
          </a>
        </div>
      )}
    </header>
  );
}